// extracted by mini-css-extract-plugin
module.exports = {"center_loading_logo":"_36_qIdFX86_9rWjqosSbWH"};